import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.DimensionalService';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class DimensionalService extends RpcClass{

    /**
     *  @class DimensionalService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/DimensionalService.DimensionalService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param productGradingDetailList {module:src/server/com/silkplm/model/plm/dictionaries/ProductGradingDetail.ProductGradingDetail[]} 
     * @param sizeForProductGradingList {module:src/server/com/silkplm/model/plm/SizeForProductGrading.SizeForProductGrading[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, java.math.BigDecimal>[]>}
     */
     calculateProductGradingAlgorithmForAllEntities(productGradingDetailList, sizeForProductGradingList) {
            return RpcClass.rpcCall('/rpc/plm/services/dimensional-service/calculate-product-grading-algorithm-for-all-entities', [productGradingDetailList, sizeForProductGradingList]);
    }
    /** 
     * @async
     * @param productGradingId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     findDetailsForProductGrading(productGradingId) {
            return RpcClass.rpcCall('/rpc/plm/services/dimensional-service/find-details-for-product-grading', [productGradingId]);
    }
    /** 
     * @async
     * @param productGradingDetail {module:src/server/com/silkplm/model/plm/dictionaries/ProductGradingDetail.ProductGradingDetail} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     generateReportForProductGradingDetail(productGradingDetail) {
            return RpcClass.rpcCall('/rpc/plm/services/dimensional-service/generate-report-for-product-grading-detail', [productGradingDetail]);
    }
    /** 
     * @async
     * @param categoryId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/Size.Size[]>}
     */
     listCurrentlyAddedSizesToCategory(categoryId) {
            return RpcClass.rpcCall('/rpc/plm/services/dimensional-service/list-currently-added-sizes-to-category', [categoryId]);
    }
    /** 
     * @async
     * @param productGradingId {string} 
     * @param sizeGroupName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/ProductGradingDetail.ProductGradingDetail[]>}
     */
     listProductGradingDetailForSizeGroupName(productGradingId, sizeGroupName) {
            return RpcClass.rpcCall('/rpc/plm/services/dimensional-service/list-product-grading-detail-for-size-group-name', [productGradingId, sizeGroupName]);
    }
    /** 
     * @async
     * @param productGradingId {string} 
     * @param sizeGroupName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/ProductGradingDataInfo.ProductGradingDataInfo>}
     */
     loadDataForProductGradingDetail(productGradingId, sizeGroupName) {
            return RpcClass.rpcCall('/rpc/plm/services/dimensional-service/load-data-for-product-grading-detail', [productGradingId, sizeGroupName]);
    }
    /** 
     * @async
     * @param productGradingDetail {module:src/server/com/silkplm/model/plm/dictionaries/ProductGradingDetail.ProductGradingDetail} 
     * @param sizesForProductGradingList {module:src/server/com/silkplm/model/plm/SizeForProductGrading.SizeForProductGrading[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/ProductGradingDetailResultInfo.ProductGradingDetailResultInfo>}
     */
     productGradingAlgorithmFormula(productGradingDetail, sizesForProductGradingList) {
            return RpcClass.rpcCall('/rpc/plm/services/dimensional-service/product-grading-algorithm-formula', [productGradingDetail, sizesForProductGradingList]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.DimensionalService';
metadata.__type_short__ = 'DimensionalService';
DimensionalService.prototype.__metadata__ = metadata;

DimensionalService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/DimensionalService */
export default DimensionalService

export { DimensionalService }
